import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextField } from '@tryhackme/thm-ui-components';
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useMemo } from 'react';
import { FrequencyType } from 'src/common/enums/categorization-dashboard';
import { Controller, useFormContext, useWatch } from 'src/common/form';
import { StyledFormGroup, StyledRow } from '../rule/rule.styles';
import { StyledButton, StyledCard } from './frequency.styles';
export const Frequency = ({
  path,
  handleRemove
}: {
  path: string;
  handleRemove: () => void;
}) => {
  const {
    control,
    register
  } = useFormContext();
  const [frequency] = useWatch({
    control,
    name: [`${path}.frequency.type`]
  });
  const frequencyOptions = useMemo(() => Object.values(FrequencyType).map(type => ({
    label: type,
    value: type
  })), []);
  const selectedFrequency = useMemo(() => frequencyOptions.find(option => option.value === frequency), [frequency, frequencyOptions]);
  return <StyledRow data-sentry-element="StyledRow" data-sentry-component="Frequency" data-sentry-source-file="frequency.tsx">
      <StyledCard data-sentry-element="StyledCard" data-sentry-source-file="frequency.tsx">
        <StyledRow data-sentry-element="StyledRow" data-sentry-source-file="frequency.tsx">
          <StyledFormGroup data-sentry-element="StyledFormGroup" data-sentry-source-file="frequency.tsx">
            <StyledFormGroup data-sentry-element="StyledFormGroup" data-sentry-source-file="frequency.tsx">
              <TextField {...register(`${path}.frequency.amount`)} id="frequency-amount" data-testid="frequency.amount" variant="input" type="number" label="seen in the last" placeholder="N" labelPosition="left" maxLength={5} data-sentry-element="TextField" data-sentry-source-file="frequency.tsx" />

              <Controller control={control} name={`${path}.frequency.type`} render={({
              field: {
                onChange
              }
            }) => <TextField variant="select" isMulti={false} selected={selectedFrequency} isSearchable={false} options={frequencyOptions} handleSelection={option => onChange(option?.value)} />} data-sentry-element="Controller" data-sentry-source-file="frequency.tsx" />
            </StyledFormGroup>

            <StyledButton variant="outlined" color="secondary" onClick={handleRemove} data-sentry-element="StyledButton" data-sentry-source-file="frequency.tsx">
              <FontAwesomeIcon icon={faTrashCan} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="frequency.tsx" />
            </StyledButton>
          </StyledFormGroup>
        </StyledRow>
      </StyledCard>
    </StyledRow>;
};